import React from 'react';

type Props = {
  icon: string;
  title?: string;
  onClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  className?: string;
};

const Icon = ({ icon, title, onClick, className }: Props) => {
  const classes = [`icon-${icon}`];
  if (className) classes.push(className);

  return <i className={classes.join(' ')} onClick={onClick} title={title} />;
};

export default Icon;
